import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: l,
  titleId: o,
  ...s
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M114.484 64.074c-13.593-.707-25.491 3.652-35.405 12.999s-14.936 21.114-14.936 34.852v63.897c0 25.348 19.463 46.296 44.81 47.855 371.617 22.375 668.865 319.622 691.239 691.238 1.559 25.347 22.635 45.09 48.126 44.809h63.622c13.736 0 25.508-5.02 34.85-14.933 9.345-9.769 13.709-21.945 12.999-35.681C934.442 453.934 569.796 89.429 114.481 64.082zm1.382 281.306c-13.881-1.132-26.313 2.961-36.513 12.449s-15.216 21.387-15.216 35.405v63.899c0 24.785 18.644 45.308 43.428 47.573 217.816 20.535 391.334 193.772 411.867 411.588 2.267 24.784 22.792 43.703 47.574 43.703h63.899c14.02 0 25.917-5.294 35.405-15.49 9.345-10.196 13.582-22.632 12.449-36.513-24.927-299.247-263.504-537.693-562.895-562.615zm79.387 351.845c-72.478.096-131.171 58.906-131.111 131.389-.06 72.478 58.633 131.294 131.111 131.39a131.283 131.283 0 0 0 131.386-131.386 131.28 131.28 0 0 0-131.386-131.385z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = c(i);
export {
  n as default
};
